import { render, staticRenderFns } from "./scenicSpotList.vue?vue&type=template&id=77aa450a&scoped=true&"
import script from "./scenicSpotList.vue?vue&type=script&lang=js&"
export * from "./scenicSpotList.vue?vue&type=script&lang=js&"
import style0 from "./scenicSpotList.vue?vue&type=style&index=0&id=77aa450a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa450a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77aa450a')) {
      api.createRecord('77aa450a', component.options)
    } else {
      api.reload('77aa450a', component.options)
    }
    module.hot.accept("./scenicSpotList.vue?vue&type=template&id=77aa450a&scoped=true&", function () {
      api.rerender('77aa450a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/strategy/scenicSpotList.vue"
export default component.exports